var render = function render(){var _vm=this,_c=_vm._self._c;return _c('activtyList',{attrs:{"orgType":_vm.orgType}})
}
var staticRenderFns = []

export { render, staticRenderFns }